import * as R from 'ramda'

export const setErrors = (state, action) => {
  const { error, interception } = action.payload
  return R.pipe(
    R.assoc('interception', interception),
    R.assoc('error', error)
  )(state)
}

export const clearErrors = (state, _) => {
  return R.pipe(R.assoc('interception', null), R.assoc('error', null))(state)
}
